import { Routes } from '@angular/router';
import { ROUTER_PATHS } from '@shared/constants/router-paths.constants';
import { PERMISSIONS } from '@shared/constants/permission.constants';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { authGuard } from '@shared/guards/auth.guard';
import { permissionGuard } from '@shared/guards/permission.guard';

export const APP_ROUTES: Routes = [
    {
        path: ROUTER_PATHS.PAGE_NOT_FOUND,
        loadComponent: () => import('@features/general/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent),
    },
    {
        path: ROUTER_PATHS.DEEPLINK.BASE,
        loadComponent: () => import('@features/general/deeplink-resolve-page/deeplink-resolve-page.component').then(c => c.DeeplinkResolvePageComponent),
        canActivate: [authGuard],
    },
    {
        path: '',
        loadChildren: () => import('@features/modules/modules.routes').then(r => r.MODULES_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.AUTH.BASE,
        loadChildren: () => import('@features/auth/auth-page.routes').then(r => r.AUTH_ROUTES)
    },
    {
        path: ROUTER_PATHS.PROFILE.BASE,
        loadComponent: () => import('@features/profile/profile.component').then(c => c.ProfileComponent),
        canActivate: [authGuard]
    },
    {
        path: ':clientId/cue-system-setup',
        loadChildren: () => import('@features/cue-system-setup/cue-system-setup.routes').then(r => r.CUE_SYSTEM_SETUP_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.ORDER_MANAGEMENT.BASE,
        loadChildren: () => import('@features/order-management/order-management.routes').then(r => r.ORDER_MANAGEMENT_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ':clientId/order-management/:orderId/notes',
        loadComponent: () => import('@features/order-management/pages/order-notes-page/order-notes-page.component').then(c => c.OrderNotesPageComponent),
        canActivate: [authGuard]
    },
    {
        path: ':clientId/customers',
        loadChildren: () => import('@features/customer/customer.routes').then(r => r.CUSTOMER_ROUTES),
        canActivate: [authGuard]
    },
    {
        path : ':clientId/product-management',
        loadChildren: () => import('@features/product-management/product-management.routes').then(r => r.PRODUCT_MANAGEMENT_ROUTES),
        canActivate: [authGuard, permissionGuard],
        data: {
            permission: PERMISSIONS.PERMISSION_PRODUCT_MANAGEMENT_VIEW_PRODUCT,
            permissionDeniedRedirect: SITE_LINKS.CLIENT.DETAILS,
        },
    },
    {
        path: ROUTER_PATHS.LEAD.BASE,
        loadChildren: () => import('@features/lead/lead.routes').then(r => r.LEAD_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.GAS_PRICING.BASE,
        loadChildren: () => import('@features/gas-pricing/gas-pricing.routes').then(r => r.GAS_PRICING_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.WORKBENCH.BASE,
        loadChildren: () => import('@features/workbench/workbench.routes').then(r => r.WORKBENCH_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.SERVICE_MANAGEMENT.BASE,
        loadChildren: () => import('@features/service/service.routes').then(r => r.SERVICE_ROUTES),
        // loadComponent: () => import('@features/service/pages/service-base-page/service-base-page.component').then(c => c.ServiceBasePageComponent),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.DELIVERY_PLANNING_MANAGEMENT.BASE,
        loadChildren: () => import('@features/delivery-planning/delivery-planning.routes').then(r => r.DELIVERY_PLANNING_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.PROMOTIONS.BASE,
        loadChildren: () => import('@features/promotions/promotions.routes').then(r => r.PROMOTIONS_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.INVENTORY_MANAGEMENT.BASE,
        loadChildren: () => import('@features/inventory-management/inventory-management.routes').then(r => r.INVENTORY_MANAGEMENT_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.STATEMENTS.BASE,
        loadChildren: () => import('@features/statements/statements.route').then(r => r.STATEMENTS_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.ADJUSTMENTS.BASE,
        loadChildren: () => import('@features/adjustment/adjustment.routes').then(r => r.ADJUSTMENT_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.BUDGET_ACCOUNTS_MANAGEMENT.BASE,
        loadChildren: () => import('@features/budget-accounts-management/budget-accounts-management.routes').then(r => r.BUDGET_ACCOUNTS_MANAGEMENT_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.ASSET_MANAGEMENT.BASE,
        loadChildren: () => import('@features/asset-management/asset-management.routes').then(r => r.ASSET_MANAGEMENT_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.INSPECTION_MANAGEMENT.BASE,
        loadChildren: () => import('@features/inspection-management/inspection-management.routes').then(r => r.INSPECTION_MANAGEMENT_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: '',
        loadChildren: () => import('@features/invoicing/invoicing.routes').then(r => r.INVOICING_ROUTES),
        canActivate: [authGuard]
    }
];
